import { render, staticRenderFns } from "./issues.vue?vue&type=template&id=486e49b0&lang=pug&"
import script from "./issues.vue?vue&type=script&lang=js&"
export * from "./issues.vue?vue&type=script&lang=js&"
import style0 from "./issues.vue?vue&type=style&index=0&id=486e49b0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports